const groupCls = "_275gu7xni";
const itemCls = "_275ir583o";
const fieldsetCls = "_275f1hl7zaf";
const legendCls = "_275l1dbmtry";
const desktopLegendCls = "_275du76l5o";
const mobileLegendCls = "_275mozmtwr";

export { desktopLegendCls, fieldsetCls, groupCls, itemCls, legendCls, mobileLegendCls };
import "./speech-synthesis.style.linaria.module.css";
//# sourceMappingURL=speech-synthesis.style.js.map
